import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { FC } from 'react';
import { IoIosHelpCircleOutline } from 'react-icons/io';
import { MdShield } from 'react-icons/md';

import { PRIVACY_MODE_DESCRIPTION } from './account-privacy-section';
import { AccountPrivacyToggle } from './account-privacy-toggle';

type TProps = {
  disabled?: boolean;
};

/** Compact Privacy Mode field for the Profile tab. Saves on click, independent of the profile form. */
export const AccountProfilePrivacyMode: FC<TProps> = ({ disabled }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1.5, color: 'primary.main' }}>
        <MdShield size={18} />
        <Typography variant="subtitle2" color="primary.main">
          Privacy Mode
        </Typography>
      </Box>

      <Stack direction="row" alignItems="center" spacing={2}>
        <AccountPrivacyToggle disabled={disabled} />
        <Tooltip title={PRIVACY_MODE_DESCRIPTION}>
          <Box sx={{ display: 'flex', cursor: 'pointer', color: 'text.secondary' }}>
            <IoIosHelpCircleOutline size={30} />
          </Box>
        </Tooltip>
      </Stack>
    </Box>
  </Box>
);
